import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6024c4e5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024c4e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6024c4e5')) {
      api.createRecord('6024c4e5', component.options)
    } else {
      api.reload('6024c4e5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6024c4e5&scoped=true&", function () {
      api.rerender('6024c4e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/perAssignee/index.vue"
export default component.exports